import { StateSchema } from 'app/config/storeConfig/types';

export const getHtmlString = (state: StateSchema): Nullable<string> => state.renderHTML.htmlString;
